import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    IconButton,
    Box,
    Container,
    Typography,
    Alert,
    Snackbar,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Card,
    List,
    ListItem,
    ListItemButton,
    Radio,
    TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid
} from '@mui/material';
import { Visibility, Refresh, FilterList  } from '@mui/icons-material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { useNavigate } from 'react-router-dom'; 

const ListaPasesSalida = () => {
    const [pases, setPases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [areas, setAreas] = useState([]);
    const [conductores, setConductores] = useState([]);
    const [vehiculos, setVehiculos] = useState([]);
    const [rutas, setRutas] = useState([]);

    // Estados para la paginación
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    // Estado para el filtro de estado
    const [filtroEstado, setFiltroEstado] = useState('todos');

    // Estados para la reasignación de conductor
    const [reasignarDialog, setReasignarDialog] = useState(false);
    const [paseSeleccionado, setPaseSeleccionado] = useState(null);
    const [conductorSeleccionado, setConductorSeleccionado] = useState('');
    const [cargandoReasignacion, setCargandoReasignacion] = useState(false);

    // Estado para notificaciones
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    // Hook de navegación
    const navigate = useNavigate();

    // Fetch data from API
    useEffect(() => {
        fetchPases();
        fetchDatosAdicionales();
    }, []);

    const fetchPases = async () => {
        try {
            setLoading(true);
            const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/pases/');
            if (!response.ok) throw new Error('Error al cargar pases de salida');
            const data = await response.json();
            setPases(data);
        } catch (err) {
            setError(err.message);
            showSnackbar(`Error: ${err.message}`, 'error');
        } finally {
            setLoading(false);
        }
    };

    const fetchDatosAdicionales = async () => {
        try {
            // Fetch áreas
            const areasResponse = await fetch('https://bei360.injupemp.gob.hn:8444/api/areas/');
            if (areasResponse.ok) {
                const areasData = await areasResponse.json();
                setAreas(areasData);
            }

            // Fetch conductores
            const conductoresResponse = await fetch('https://bei360.injupemp.gob.hn:8444/api/conductores/');
            if (conductoresResponse.ok) {
                const conductoresData = await conductoresResponse.json();
                setConductores(conductoresData);
            }

              // Fetch conductores
            const rutasResponse = await fetch('https://bei360.injupemp.gob.hn:8444/api/rutas/');
            if (rutasResponse.ok) {
                const rutasData = await rutasResponse.json();
                setRutas(rutasData);
            }

            // Fetch vehículos
            const vehiculosResponse = await fetch('https://bei360.injupemp.gob.hn:8444/api/vehiculos/');
            if (vehiculosResponse.ok) {
                const vehiculosData = await vehiculosResponse.json();
                setVehiculos(vehiculosData);
            }
        } catch (err) {
            console.error('Error cargando datos adicionales:', err);
        }
    };


 // Función para obtener nombre del área
    const getNombreRuta = (rutaId) => {
        const ruta = rutas.find(r => r.id === rutaId);
        return ruta ? ruta.nombre : 'N/A';
    };

    // Función para obtener nombre del área
    const getNombreArea = (areaId) => {
        const area = areas.find(a => a.id === areaId);
        return area ? area.nombre : 'N/A';
    };

    // Función para obtener nombre del conductor
    const getNombreConductor = (conductorId) => {
        const conductor = conductores.find(c => c.id === conductorId);
        return conductor ? `${conductor.nombre} ${conductor.apellido}` : 'N/A';
    };

    // Función para obtener información del vehículo
    const getInfoVehiculo = (vehiculoId) => {
        const vehiculo = vehiculos.find(v => v.id === vehiculoId);
        return vehiculo ? ` (${vehiculo.marca} ${vehiculo.modelo} ${vehiculo.vin})` : 'N/A';
    };

    // Formatear fecha
    const formatFecha = (fecha) => {
        if (!fecha) return 'N/A';
        return new Date(fecha).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    };

    // Obtener color según estado
    const getColorEstado = (estado) => {
        switch (estado) {
            case 'abierto':
                return 'warning';
            case 'en_ruta':
                return 'primary';
            case 'completado':
                return 'success';
            case 'anulado':
                return 'error';
            default:
                return 'default';
        }
    };

    // Traducir estado
    const traducirEstado = (estado) => {
        const estados = {
            'abierto': 'Abierto',
            'anulado': 'Anulado',
            'en_ruta': 'En Ruta',
            'completado': 'Completado',
        };
        return estados[estado] || estado;
    };

    // Filtrar pases por estado según el filtro seleccionado
    const filtrarPasesPorEstado = () => {
        switch (filtroEstado) {
            case 'abierto':
                return pases.filter(pase => pase.estado === 'abierto');
            case 'en_ruta':
                return pases.filter(pase => pase.estado === 'en_ruta');
            case 'completado':
                return pases.filter(pase => pase.estado === 'completado');
            case 'anulado':
                return pases.filter(pase => pase.estado === 'anulado');    
            case 'todos':
            default:
                return pases;
        }
    };

    // Obtener pases filtrados
    const pasesFiltrados = filtrarPasesPorEstado();

    // Calcular pases paginados
    const pasesPaginados = pasesFiltrados.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    // Navegar a la pantalla de detalles
    const handleVerDetalles = (pase) => {
        navigate(`/Flotas/DetallesPaseSalida/${pase.id}`, { state: { pase, areas, conductores, vehiculos, rutas } });
    };

    // Abrir diálogo de reasignación
    const handleAbrirReasignacion = (pase) => {
        // Verificar si el pase está en estado abierto
        if (pase.estado !== 'abierto') {
            showSnackbar('Solo se puede reasignar conductor a pases en estado "Abierto"', 'warning');
            return;
        }
        
        setPaseSeleccionado(pase);
        setConductorSeleccionado(pase.conductor || '');
        setReasignarDialog(true);
    };

    // Cerrar diálogo de reasignación
    const handleCerrarReasignacion = () => {
        setReasignarDialog(false);
        setConductorSeleccionado('');
    };

    // Reasignar conductor
    const handleReasignarConductor = async () => {
        if (!conductorSeleccionado) {
            showSnackbar('Debe seleccionar un conductor', 'error');
            return;
        }

        try {
            setCargandoReasignacion(true);
            const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/pases/${paseSeleccionado.id}/`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    conductor: conductorSeleccionado
                }),
            });

            if (!response.ok) throw new Error('Error al reasignar conductor');

            showSnackbar('Conductor reasignado exitosamente', 'success');
            fetchPases(); // Recargar la lista de pases
            handleCerrarReasignacion();
        } catch (err) {
            showSnackbar(`Error: ${err.message}`, 'error');
        } finally {
            setCargandoReasignacion(false);
        }
    };

    // Mostrar notificación
    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    // Cerrar notificación
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    // Recargar datos
    const handleRecargar = () => {
        fetchPases();
        fetchDatosAdicionales();
        // Resetear paginación al recargar
        setPage(0);
    };

    // Handlers para paginación
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Resetear a la primera página cuando cambia el número de filas por página
    };

    // Handler para cambiar filtro de estado
    const handleChangeFiltroEstado = (event) => {
        setFiltroEstado(event.target.value);
        setPage(0); // Resetear a la primera página cuando se cambia el filtro
    };

    // Contador de pases por estado
    const contarPasesPorEstado = () => {
        return {
            abierto: pases.filter(pase => pase.estado === 'abierto').length,
            en_ruta: pases.filter(pase => pase.estado === 'en_ruta').length,
            completado: pases.filter(pase => pase.estado === 'completado').length,
            anulado: pases.filter(pase => pase.estado === 'anulado').length,
            todos: pases.length
        };
    };

    const contadores = contarPasesPorEstado();

    if (loading) {
        return (
            <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                <CircularProgress />
                <Typography variant="h6" sx={{ ml: 2 }}>Cargando pases de salida...</Typography>
            </Container>
        );
    }

    return (
        <Container style={{ marginTop: 15 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h4" fontWeight="bold">
                    Pases de Salida
                </Typography>
                <Button
                    variant="outlined"
                    startIcon={<Refresh />}
                    onClick={handleRecargar}
                    sx={{ borderRadius: 2 }}
                >
                    Actualizar
                </Button>
            </Box>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            {/* Filtro con Select */}
            <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                        <InputLabel id="filtro-estado-label">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <FilterList sx={{ mr: 1, fontSize: 20 }} />
                                Filtrar por estado
                            </Box>
                        </InputLabel>
                        <Select
                            labelId="filtro-estado-label"
                            value={filtroEstado}
                            onChange={handleChangeFiltroEstado}
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FilterList sx={{ mr: 1, fontSize: 20 }} />
                                    Filtrar por estado
                                </Box>
                            }
                        >
                            <MenuItem value="todos">
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <span>Todos los estados</span>
                                    <Chip 
                                        label={contadores.todos} 
                                        size="small" 
                                        sx={{ ml: 1, height: '20px', fontSize: '0.7rem' }}
                                    />
                                </Box>
                            </MenuItem>
                            <MenuItem value="abierto">
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <span>Abierto</span>
                                    <Chip 
                                        label={contadores.abierto} 
                                        size="small" 
                                        color="warning"
                                        sx={{ ml: 1, height: '20px', fontSize: '0.7rem' }}
                                    />
                                </Box>
                            </MenuItem>
                            <MenuItem value="en_ruta">
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <span>En Ruta</span>
                                    <Chip 
                                        label={contadores.en_ruta} 
                                        size="small" 
                                        color="primary"
                                        sx={{ ml: 1, height: '20px', fontSize: '0.7rem' }}
                                    />
                                </Box>
                            </MenuItem>
                            <MenuItem value="completado">
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <span>Completado</span>
                                    <Chip 
                                        label={contadores.completado} 
                                        size="small" 
                                        color="success"
                                        sx={{ ml: 1, height: '20px', fontSize: '0.7rem' }}
                                    />
                                </Box>
                            </MenuItem>
                             <MenuItem value="anulado">
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <span>Anulado</span>
                                    <Chip 
                                        label={contadores.anulado} 
                                        size="small" 
                                        color="error"
                                        sx={{ ml: 1, height: '20px', fontSize: '0.7rem' }}
                                    />
                                </Box>
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                
                {/* Información del filtro actual */}
                <Grid item xs={12} sm={6} md={8}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Typography variant="body2" color="textSecondary" sx={{ mr: 2 }}>
                            Mostrando {pasesFiltrados.length} de {pases.length} pases
                        </Typography>
                        {filtroEstado !== 'todos' && (
                            <Chip
                                label={`Filtro: ${traducirEstado(filtroEstado)}`}
                                color={getColorEstado(filtroEstado)}
                                size="small"
                                onDelete={() => setFiltroEstado('todos')}
                            />
                        )}
                    </Box>
                </Grid>
            </Grid>

            {pases.length === 0 ? (
                <Card sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h6" color="textSecondary">
                        No hay pases de salida registrados
                    </Typography>
                </Card>
            ) : pasesFiltrados.length === 0 ? (
                <Card sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h6" color="textSecondary">
                        No hay pases con el estado seleccionado
                    </Typography>
                    <Button 
                        variant="outlined" 
                        onClick={() => setFiltroEstado('todos')}
                        sx={{ mt: 2 }}
                    >
                        Ver todos los pases
                    </Button>
                </Card>
            ) : (
                <>
                    <TableContainer component={Paper} elevation={3}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#19438C' }}>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>ID</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Área Solicitante</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Conductor</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Rutas</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Vehículo</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha Solicitud</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Acciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pasesPaginados.map((pase) => (
                                    <TableRow key={pase.id} hover>
                                        <TableCell>{pase.id}</TableCell>
                                        <TableCell>{getNombreArea(pase.area)}</TableCell>
                                        <TableCell>{getNombreConductor(pase.conductor)}</TableCell>
                                        <TableCell>{getNombreRuta(pase.ruta)}</TableCell>
                                        <TableCell>{getInfoVehiculo(pase.vehiculo)}</TableCell>
                                        <TableCell>{formatFecha(pase.fecha_solicitud)}</TableCell>
                                        <TableCell>
                                            <Chip
                                                label={traducirEstado(pase.estado)}
                                                color={getColorEstado(pase.estado)}
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                onClick={() => handleVerDetalles(pase)}
                                                color="primary"
                                                title="Ver detalles"
                                            >
                                                <Visibility />
                                            </IconButton>
                                            {pase.estado === 'abierto' && (
                                                <IconButton
                                                    onClick={() => handleAbrirReasignacion(pase)}
                                                    color="primary"
                                                    title="Reasignar conductor"
                                                >
                                                    <GroupAddIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* PAGINACIÓN */}
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={pasesFiltrados.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage="Filas por página:"
                        labelDisplayedRows={({ from, to, count }) => 
                            `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
                        }
                    />
                </>
            )}

            {/* Diálogo de reasignación de conductor */}
            <Dialog
                open={reasignarDialog}
                onClose={handleCerrarReasignacion}
                maxWidth={false}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '500px',
                        maxWidth: '100%',
                        maxHeight: '90vh',
                        height: '500px',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }
                }}
            >
                <DialogTitle sx={{ 
                    backgroundColor: '#19438C', 
                    color: 'white', 
                    fontWeight: 'bold',
                    textAlign: 'center',
                    py: 2
                }}>
                    Reasignar Conductor - Pase #{paseSeleccionado?.id}
                </DialogTitle>
                
                <DialogContent sx={{ 
                    flex: 1,          
                    overflowY: 'auto', 
                    pt: 3, 
                    pb: 1,
                    minHeight: '200px', 
                }}>
                    <Typography variant="body1" sx={{ mb: 2, fontWeight: 'medium' }}>
                        Seleccione el nuevo conductor:
                    </Typography>

                    <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
                        <List disablePadding>
                            {conductores.filter(conductor => conductor.estado === 'Activo').length === 0 ? (
                                <Box textAlign="center" p={3}>
                                    <Typography color="textSecondary">No hay conductores disponibles</Typography>
                                </Box>
                            ) : (
                                conductores.filter(conductor => conductor.estado === 'Activo').map((conductor) => {
                                    const isCurrent = paseSeleccionado?.conductor === conductor.id;
                                    const isSelected = conductorSeleccionado === conductor.id;
                                    
                                    return (
                                        <ListItem key={conductor.id} disablePadding>
                                            <ListItemButton
                                                onClick={() => !isCurrent && setConductorSeleccionado(conductor.id)}
                                                disabled={isCurrent || cargandoReasignacion}
                                                sx={isCurrent ? { 
                                                    opacity: 0.6,
                                                    cursor: 'not-allowed',
                                                    '&:hover': {
                                                        backgroundColor: 'transparent'
                                                    }
                                                } : {
                                                    '&:hover': {
                                                        backgroundColor: '#f5f5f5'
                                                    }
                                                }}
                                            >
                                                <Radio
                                                    checked={isSelected}
                                                    disabled={isCurrent}
                                                    sx={{
                                                        color: isCurrent ? 'grey.500' : '#19438C',
                                                        '&.Mui-checked': {
                                                            color: isCurrent ? 'grey.500' : '#FF0000',
                                                        },
                                                    }}
                                                />
                                                
                                                <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
                                                    <Typography 
                                                        variant="body1" 
                                                        fontWeight="medium"
                                                        color={isCurrent ? 'text.disabled' : 'text.primary'}
                                                    >
                                                        {conductor.nombre} {conductor.apellido}
                                                        {isCurrent && (
                                                            <Chip 
                                                                label="Actual" 
                                                                size="small" 
                                                                sx={{ 
                                                                    ml: 1, 
                                                                    backgroundColor: 'grey.300',
                                                                    color: 'grey.700',
                                                                    fontSize: '0.65rem',
                                                                    height: '20px'
                                                                }} 
                                                            />
                                                        )}
                                                    </Typography>
                                                    <Typography 
                                                        variant="body2" 
                                                        color={isCurrent ? 'text.disabled' : 'text.secondary'}
                                                    >
                                                        Licencia: {conductor.tipo_licencia} | Tel: {conductor.telefono}
                                                    </Typography>
                                                </Box>
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })
                            )}
                        </List>
                    </Box>
                </DialogContent>
                
                <DialogActions sx={{ 
                    p: 3, 
                    borderTop: '1px solid #e0e0e0',
                    justifyContent: 'flex-end'
                }}>
                    <Button 
                        onClick={handleCerrarReasignacion}
                        disabled={cargandoReasignacion}
                        sx={{ 
                            mr: 2,
                            color: 'text.secondary',
                            '&:hover': {
                                backgroundColor: '#f5f5f5'
                            }
                        }}
                    >
                        Cancelar
                    </Button>
                    
                    <Button 
                        variant="contained"
                        onClick={handleReasignarConductor}
                        disabled={cargandoReasignacion || !conductorSeleccionado}
                        sx={{ 
                            backgroundColor: '#19438C',
                            '&:hover': {
                                backgroundColor: '#5ab4be'
                            },
                            minWidth: '180px'
                        }}
                    >
                        {cargandoReasignacion ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : 'Confirmar Reasignación'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Notificación */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default ListaPasesSalida;